<script>
export default {
  inheritAttrs: false,

  props: {
    label: {
      type: String,
      required: true,
    },

    error: {
      type: Boolean,
      required: false,
      default: false,
    },

    required: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
}
</script>

<template>
  <label :class="{ 'text-error': error }">
    <div class="mb-2 font-medium">
      {{ label }}
      <span v-if="required" class="opacity-50">*</span>
    </div>

    <slot />
  </label>
</template>
